//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  answerAjax,revive
} from '@/api/ajax.js'
import {mapActions,mapState,mapMutations} from 'vuex'
import Resurrection from '@/components/Resurrection.vue'

export default {
  name: 'play',
  data() {
    return {
      coverImgs: ['http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%AD%94%E9%A2%98%E9%A1%B5-%E6%8B%BC%E5%9B%BE%E6%9C%AA%E5%BE%97%EF%BC%88%E5%B7%A6%E4%B8%8A%EF%BC%89@2x.png',
        'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%AD%94%E9%A2%98%E9%A1%B5-%E6%8B%BC%E5%9B%BE%E6%9C%AA%E5%BE%97%EF%BC%88%E5%8F%B3%E4%B8%8A%EF%BC%89@2x.png',
        'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%AD%94%E9%A2%98%E9%A1%B5-%E6%8B%BC%E5%9B%BE%E6%9C%AA%E5%BE%97%EF%BC%88%E5%B7%A6%E4%B8%8B%EF%BC%89@2x.png',
        'http://yiyang.oss-cn-beijing.aliyuncs.com/html/AnswerGold/%E7%AD%94%E9%A2%98%E9%A1%B5-%E6%8B%BC%E5%9B%BE%E6%9C%AA%E5%BE%97%EF%BC%88%E5%8F%B3%E4%B8%8B%EF%BC%89@2x.png'
      ],
      list: [], //4题
      activeIndex: -1, //当题选项
      canActive: true,
      time: '---',
      intervalId: null, //倒计时
      questionIndex: 0, // 题坐标
      showLog:false, // 是否显示 复活卡层
      reviveNum:0, // 复活卡数量
      integral:0 // 用户积分
    }
  },
  methods: {
    ...mapActions([
      'change'
    ]),
    ...mapMutations([
      'SETREVICE'
    ]),
    jumpWrongPage(questionIndex,questionId){
        this.questionIndex = questionIndex
      if(this.hasUserRevice){// 未使用过复活卡
          this.showLog = true
      }else{
        this.$router.push({
          name: 'wrong',
          query: {
            rightNum: questionIndex,
            wrongId: questionId,
            first:true
          }
        })
      }

    },
    // 点击答案提交  每次点击 上报一次
    sendQuestion(answerResult) {
      let answerList = ['A', 'B', 'C', 'D', 'E']
      let activeQuestionId = this.list[this.questionIndex].id
      answerAjax.answerSingleQuestion({
        questionId: activeQuestionId,
        answer: answerResult ? answerResult : answerList[this.activeIndex]
      }).then(res => {
        if (res.data.isRight == 1) { // right
          this.canActive = true
          this.questionIndex += 1
          this.activeIndex = -1
        } else if (res.data.isRight != 1) { //wrong
          this.jumpWrongPage(this.questionIndex,activeQuestionId)
        }
      }).catch(e => {
        this.$vux.toast.show({
          text: '请您检查网络',
          type: 'text',
          width: '7rem'
        })
      })
    },
    activeClick(item, index, parentItem) {
      if (this.canActive) {
        this.canActive = false
        this.activeIndex = index
        this.sendQuestion(null)
      }
    },
    useReviveCard(arg){
      if(arg){
          this.canActive = true
        this.questionIndex += 1
        this.activeIndex = -1
      }
    },
    //isRight 0 错误 1 答对 2 答题时间到并未选择答案 3 使用复活卡
    getTimeAndOption() {
      answerAjax.obtainUserRandomQuestion().then(list => {
        answerAjax.obtainTiming().then(time => {
          revive.myReviveCard().then(res => { //获取用户复活卡和积分， 必须在获取题之后
              this.reviveNum = res.data.count
              this.integral = res.data.integral
          })
          this.time = time.data.timing
          // if (this.time) {
            this.list = list.data.data
            this.list.filter((item, index) => {
              if (item.isRight) {
                if (item.isRight == '0') { // 答错了
                  this.jumpWrongPage(index,item.id)
                  if(index > 0){
                    this.coverImgs[index-1] = `http://cdn.yxvzb.com/html/AnswerGold/${index}.png`
                  }
                  return false
                } else if ((item.isRight == '1' || item.isRight == '3') && index < 3 && !this.list[index + 1].isRight) { //之前的答对了但是没有打完 返回后可以继续答题
                  this.questionIndex = index + 1
                } else if (index >= 3) { //防止后退
                  this.$router.push({
                    name: 'correct',
                    query:{
                        first:true
                    }
                  })
                }
                this.coverImgs[index] = `http://cdn.yxvzb.com/html/AnswerGold/${index+1}.png`
                // console.log(index)
              }
            })
            this.intervalId = setInterval(() => {
              if (this.time <= 0) { // 时间到
                clearInterval(this.intervalId)
                answerAjax.endTimeSubmit({questionId:this.list[this.questionIndex].id}).then(res =>{
                  this.$router.push({
                    name: 'wrong',
                    query: {
                      rightNum: this.questionIndex,
                      wrongId: this.list[this.questionIndex].id,
                      first:true
                    }
                  })
                })
              } else {
                if (typeof this.time == 'number') {
                  this.time -= 1
                }
              }
            }, 1000)
          // } else { // 答过了
          //   this.$router.push({
          //     name: 'finshed'
          //   })
          // }
          this.change(false)
        })
      })

      // this.$http.all([answerAjax.obtainUserRandomQuestion(), answerAjax.obtainTiming()]).then(this.$http.spread((list, time) => {
      //   this.time =time.data.timing
      //   if(this.time){
      //     this.list =list.data.data
      //     this.intervalId = setInterval(() => {
      //       if (this.time <= 0) { // 时间到
      //         console.log('----------')
      //         this.$router.push({name:'wrong',query:{rightNum:this.questionIndex,wrongId:this.list[this.questionIndex].id}})
      //       }
      //       else {
      //         if(typeof this.time == 'number'){
      //           this.time-=1
      //         }
      //       }
      //     }, 1000)
      //   }else { // 答过了
      //
      //     this.$router.push({name:'finshed'})
      //   }
      //
      // })).catch(() => {
      //
      // })
    }
  },
  computed: {
    ...mapState({
        hasUserRevice: state => state.hasUserRevice
    })
  },
  components: {
    Resurrection
  },
  watch: {
    questionIndex(n, o) {
      if (n > 0) {
        this.coverImgs[n - 1] = `http://cdn.yxvzb.com/html/AnswerGold/${n}.png`
      }
      if (n > 3) {
        this.$router.push({
          name: 'correct',
          query:{
              first:true
          }

        })
      }
    }
  },
  created() {
    this.change(true)
    this.getTimeAndOption()

  },
  beforeDestroy() {
    if (this.intervalId) {

      clearInterval(this.intervalId)
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/Play/index.vue